const headerInit = (el: HTMLElement) => {
  const toggler: HTMLInputElement = el.querySelector('#mobile-toggle');
  const mobileMenu: HTMLElement = document.querySelector('.mobile-menu');
  let isTransparent = false;

  if (el.classList.contains('header--transparent')) {
    isTransparent = true;
  }

  if (isTransparent) {
    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 0) {
        el.classList.remove('header--transparent');
      } else {
        el.classList.add('header--transparent');
      }
    });
  }

  toggler.addEventListener('click', (e) => {
    e.preventDefault();
    toggler.classList.toggle('checked');
    mobileMenu.classList.toggle('active');
    el.classList.toggle('header--mobile-active');
  });
};

export default headerInit;
